import { makeStyles } from '@material-ui/core/styles';

// A custom theme for this app
const useGlobalStyles = makeStyles((theme) => ({
  root: {
    minWidth: "100%",
    minHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  card: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    maxWidth: "95%",
    minWidth: "95%",
    minHeight: "100vh",
    alignItems: "center"
  },
  cardLogin: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    alignItems: "center"
  },
  paper: {
    maxWidth: "95%",

    margin: theme.spacing(5),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    }
  }
}
));

export default useGlobalStyles
